import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Card, Spinner } from "react-bootstrap";
import { API_ENDPOINTS } from "../config";

const normalizeToken = (t) => {
  const raw = String(t ?? '').trim();
  if (!raw) return '';
  return raw.replace(/^Bearer\s+/i, '').trim();
};

const getAuthHeaders = () => {
  const raw = normalizeToken(localStorage.getItem('JWToken'));
  return {
    'Content-Type': 'application/json',
    'Authorization': raw ? `Bearer ${raw}` : ''
  };
};

const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
  }
  return undefined;
};

const normalizeUser = (u) => {
  if (!u) return null;
  return {
    uid: pick(u, 'uid', 'Uid', 'id', 'Id'),
    userName: pick(u, 'userName', 'UserName', 'name', 'Name') || 'Unknown',
    isOnline: Boolean(pick(u, 'isOnline', 'IsOnline'))
  };
};

function OnlineUser() {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const candidates = useMemo(() => {
    return [
      API_ENDPOINTS.LISTONLINEUSERS,
      API_ENDPOINTS.GETONLINEUSERS,
      API_ENDPOINTS.LISTONLINEUSERS_AUTH,
      API_ENDPOINTS.LISTONLINEUSERS_PRESENCE
    ].filter(Boolean);
  }, []);

  const getListOnlineUsers = async () => {
    setLoading(true);

    for (let i = 0; i < candidates.length; i++) {
      const url = candidates[i];
      try {
        const response = await axios.get(url, {
          params: {
            limit: 50,
            _t: new Date().getTime()
          },
          headers: getAuthHeaders()
        });

        const arr = Array.isArray(response.data) ? response.data : [];
        setOnlineUsers(arr.map(normalizeUser).filter(Boolean));
        setLoading(false);
        return;
      } catch (error) {
        const status = error?.response?.status;
        if (status === 404) {
          continue;
        }

        console.error("Error fetching online users:", error);
        setOnlineUsers([]);
        setLoading(false);
        return;
      }
    }

    setOnlineUsers([]);
    setLoading(false);
  };

  useEffect(() => {
    getListOnlineUsers();

    const interval = setInterval(() => {
      getListOnlineUsers();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Card className="shadow bg-dark-transparent text-white" style={{ transform: "none" }}>
      <Card.Header className="text-center border-bottom border-secondary">
        <h5 className="mb-0 fw-bold text-uppercase ls-1">Online Users</h5>
      </Card.Header>
      <Card.Body className="p-2">
        {onlineUsers.length > 0 ? (
          <ul className="list-unstyled m-0">
            {onlineUsers.map((user) => (
              <li key={user.id} className="user-list-item d-flex align-items-center p-2 rounded">
                <span className="fw-semibold">{user.userName}</span>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center text-muted p-3">
            <small>No users online</small>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default OnlineUser;